import {AppInitService} from '../services/app-init.service';

export function appInitializer(appInit: AppInitService) {

  return () => new Promise(resolve => {
    // attempt to refresh token on app start up to auto authenticate
    /*authenticationService.refreshJwtToken()
      .subscribe()
      .add(resolve);*/
    appInit.initRefreshJwtToken();
    resolve(null);
  });
}
